import type { FaireProductEntity } from "../../entity_types/product";

export const p_736jyh97k6: FaireProductEntity = {
  token: "p_736jyh97k6",
  type: "product",
  name: "Espresso Martini Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7e03f9bb87c8aab5583558ea97fb8b5547f8f16b01b462fa40f67b0679ab11f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3dddb36cceb64ed86cb9b1b66092411f13f58e7f93ca4953c13b28f2f1f76543.jpeg",
    "https://cdn.faire.com/fastly/c07762da09ff463961f582c4f425a437d210ff606a6ce5810fadad71b95c969e.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:56.985Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
